// postMockData.ts - 게시글 더미 데이터

import { PostListItem, PostListResponse } from '../services/postApi';

export const mockAdminProfileImageUrl = '/images/header/adminProfile.png';

// 더미 게시글 데이터
export const mockPostListItems: PostListItem[] = [
  {
    post_id: 1,
    title: "의학과 공지사항 - 2025년 1학기 시험 일정",
    content: "2025년 1학기 중간고사 및 기말고사 일정을 안내드립니다...",
    post_category: "공지사항",
    reply_cnt: 12,
    view_cnt: 245,
    writer_name: "관리자",
    created_at: "2025-06-28T10:30:00",
    pinned: true
  },
  {
    post_id: 2,
    title: "해부학 강의 질문 - 근육계에 대해 궁금한 점이 있습니다",
    content: "근육의 수축 메커니즘에 대해 자세히 설명해주실 수 있나요?",
    post_category: "강의 질문",
    reply_cnt: 8,
    view_cnt: 156,
    writer_name: "김의대생",
    created_at: "2025-06-28T14:20:00",
    pinned: false
  },
  {
    post_id: 3,
    title: "의학 서적 추천 - 임상의학 입문서",
    content: "의대생들에게 도움이 될 만한 임상의학 입문서를 추천해드립니다.",
    post_category: "정보 공유",
    reply_cnt: 15,
    view_cnt: 320,
    writer_name: "이교수",
    created_at: "2025-06-28T09:45:00",
    pinned: false
  },
  {
    post_id: 4,
    title: "스터디 모집 - 생리학 스터디원을 찾습니다",
    content: "생리학 시험 대비 스터디를 함께 할 분들을 찾고 있습니다.",
    post_category: "스터디",
    reply_cnt: 6,
    view_cnt: 89,
    writer_name: "박학생",
    created_at: "2025-06-28T16:10:00",
    pinned: false
  },
  {
    post_id: 5,
    title: "병리학 실습 후기 - 현미경 관찰 체험",
    content: "이번 병리학 실습에서 현미경으로 다양한 조직을 관찰했습니다...",
    post_category: "정보 공유",
    reply_cnt: 3,
    view_cnt: 67,
    writer_name: "최의대생",
    created_at: "2025-06-28T11:30:00",
    pinned: false
  }
];

// 카테고리별 더미 데이터 필터링 함수
export const getMockDataByBoard = (board: string, page = 0, size = 20): PostListResponse => {
  let filteredData = [...mockPostListItems];

  // 게시판별 필터링
  switch (board) {
    case 'notice':
      filteredData = mockPostListItems.filter(item => item.post_category === '공지사항');
      break;
    case 'information':
      filteredData = mockPostListItems.filter(item => item.post_category === '정보 공유');
      break;
    case 'study':
      filteredData = mockPostListItems.filter(item => item.post_category === '스터디');
      break;
    case 'lecture':
      filteredData = mockPostListItems.filter(item => item.post_category === '강의 질문');
      break;
    case 'home':
    default:
      // 홈에서는 모든 데이터 표시
      filteredData = mockPostListItems;
      break;
  }

  // 핀 고정된 글을 상단으로 정렬
  filteredData.sort((a, b) => {
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });

  // 페이지네이션 적용
  const startIndex = page * size;
  const endIndex = startIndex + size;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const totalElements = filteredData.length;
  const totalPages = Math.ceil(totalElements / size);

  return {
    totalElements,
    totalPages,
    size,
    content: paginatedData,
    number: page,
    sort: {
      empty: true,
      sorted: false,
      unsorted: true
    },
    numberOfElements: paginatedData.length,
    pageable: {
      offset: startIndex,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true
      },
      paged: true,
      pageNumber: page,
      pageSize: size,
      unpaged: false
    },
    first: page === 0,
    last: page >= totalPages - 1,
    empty: paginatedData.length === 0
  };
};
